import React from "react";


const Hamburger = ({ setOpenBurger, openBurger }) => {
  return (
    <>
      <div
        className={openBurger ? "hamburger-container burgerOff" : "hamburger-container"}
        onClick={() => {

          setOpenBurger(!openBurger)

        }}
      >
        <div
          className={`line lineTop ${openBurger ? "lineTopOpen" : ""}`}
        ></div>
        <div
          className={`line lineMiddle ${openBurger ? "lineMiddleOpen" : ""}`}
        ></div>
        <div
          className={`line lineBottom ${openBurger ? "lineBottomOpen" : ""}`}
        ></div>
      </div>
    </>
  );
};

export default Hamburger;
